<template>
  <div id="plaid-link">
    <PlaidLink
      env="sandbox"
      :link_token="plaidLink"
      :products="['auth', 'transactions']"
      :onLoad="onLoad"
      :onSuccess="onSuccess"
      :onExit="onExit"
      :onEvent="onEvent"
    >
      <Button
        variant="primary"
        :class="[classNames]"
        size="sm"
      >
        Add Bank
      </Button>
    </PlaidLink>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import PlaidLink from "vue-plaid-link2";

export default {
  props: ["userName", "classNames"],
  components: {
    PlaidLink,
  },
  methods: {
    ...mapActions(["createUserIntegration"]),
    onLoad() {},
    onSuccess(public_token, metadata) {
      if (public_token) {
        const payload = {
          accountId: metadata.account_id,
          data: public_token,
        };
        this.createUserIntegration(payload).then((result) => {
          console.log(result);
          console.log("Account Added succesfully!");
        });
      }
    },
    onExit(err, metadata) {
      console.log(err);
    },
    onEvent(eventName, metadata) {},
  },
  computed: {
    ...mapGetters(["plaidLink"]),
  },
};
</script>
